<kendo-icon *ngIf="statusImage" [name]="statusImage" themeColor="primary">{{title}}</kendo-icon>
